export default __webpack_public_path__ + "static/media/fast-forward.06a30349.svg";